import useCurrentCompany from './useCurrentCompany';

const useFlipper = (flipper) => {
  const company = useCurrentCompany();

  return company.flippers[flipper];
};

export default useFlipper;
